import { useState } from "react";
import { postStaff } from "../service/staffService";
import { Staff } from "../types";

// The backend sends validation/conflict reasons as a plain-text body.
const messageOf = (err: any): string => {
  const data = err?.response?.data;
  return typeof data === "string" && data.trim() ? data : "Failed to create staff.";
};

export function useCreateStaff() {
  const [saving, setSaving] = useState(false);

  /** Returns null on success, or the reason it failed. */
  async function createStaff(data: Staff): Promise<string | null> {
    setSaving(true);
    try {
      await postStaff(data);
      return null;
    } catch (err) {
      return messageOf(err);
    } finally {
      setSaving(false);
    }
  }

  return { createStaff, saving };
}
